<template>
  <div class="blanks">
    <span v-for="(item, index) in issue.items" :key="index">
      {{ item.text }}
      <span v-if="item.length && item.content" class="blanks-opt-wrap">
        <input
          :type="item.content.inputType === 'number' ? 'text' : item.content.inputType"
          :inputMode="
            item.content.inputType === 'number' || item.content.validate === 'num'
              ? 'decimal'
              : item.content.validate === 'phone'
              ? 'numeric'
              : ''
          "
          class="blanks-input"
          :style="{ width: item.length * 10 + 'px' }"
          v-model="item.value"
          @copy="onCopy"
          @paste="onPaste"
          @cut="onCut"
          :readonly="item.readonly"
          :placeholder="item.placeholder"
        />
      </span>
    </span>
    <template v-if="questionErrorText">
      <div class="text-danger mt-1">
        <span>{{questionErrorText}}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { Blanks } from 'dygc'

export default Blanks
</script>
